import { Avatar, AvatarBadge, Flex, Text } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Facebook as FacebookIcon,
  Google as GoogleIcon,
  Line as LineIcon,
} from '../../../../context/Chakra/Icons';
import { useAppContext } from '../../../context/appContext';
import { useProfileContext } from '../context/profileContext';
import FormField from './FormField';

const BindingAccount = () => {
  const { t } = useTranslation();
  const { userData } = useProfileContext();
  const { slFeatureService } = useAppContext();

  const showGoogleAccount = useMemo(
    () =>
      slFeatureService.hasFeature('google_signup_login') && userData.google_id,
    [slFeatureService, userData.google_id],
  );

  return userData.facebook_id || userData.line_info || showGoogleAccount ? (
    <FormField label={t('users.membership.member_info.account_binding')}>
      {userData.line_info && (
        <Flex alignItems="center" marginTop="7px" marginBottom="7px">
          <Avatar src={userData.line_info.profile_pic_url} size="md">
            <AvatarBadge>
              <LineIcon color="#4CC764" boxSize="14px" />
            </AvatarBadge>
          </Avatar>
          <Text
            variant="avatarText"
            flex="1"
            marginLeft="10px"
            textAlign="left"
            className="member-center-profile__social-account-text"
          >
            {userData.line_info.name}
          </Text>
        </Flex>
      )}
      {userData.facebook_id && (
        <Flex alignItems="center" marginTop="7px" marginBottom="7px">
          <Avatar
            src={userData.facebook_info?.extra?.raw_info?.picture?.data?.url}
            size="md"
          >
            <AvatarBadge>
              <FacebookIcon color="#1877F2" boxSize="14px" />
            </AvatarBadge>
          </Avatar>
          <Text
            variant="avatarText"
            flex="1"
            marginLeft="10px"
            textAlign="left"
          >
            {userData.facebook_info?.extra?.raw_info?.name || ''}
          </Text>
        </Flex>
      )}
      {showGoogleAccount && (
        <Flex alignItems="center" marginTop="7px" marginBottom="7px">
          <Avatar src={userData.google_info?.image} size="md">
            <AvatarBadge backgroundColor="#ffffff">
              <GoogleIcon boxSize="14px" />
            </AvatarBadge>
          </Avatar>
          <Text
            variant="avatarText"
            flex="1"
            marginLeft="10px"
            textAlign="left"
          >
            {userData.google_info?.name || ''}
          </Text>
        </Flex>
      )}
    </FormField>
  ) : null;
};

export default BindingAccount;
